import React from 'react';
import SearchConditionStyled from './SearchConditionStyled';
import { useForm, Controller } from 'react-hook-form';
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  TextField,
  useTheme,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import ReplayIcon from '@material-ui/icons/Replay';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import { useIntl } from 'umi';
import webStorage from '@/utils/storageManager';
import ClearIconML from '@/components/ClearIconML/index';

const SearchCondition = (props) => {
  // const dispatch = useDispatch();
  const intl = useIntl();
  const { formatMessage } = intl;
  const { ACTIVITY_TYPE: ACTIVITY_TYPE_DICT } = webStorage.get('DICTOBJ') || {};

  const { query, searchRef } = props;
  const { handleSearch, restClick } = props;
  const { title, type, status } = query;
  const theme = useTheme();
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    // getValues,
    watch,
  } = useForm({
    defaultValues: {
      title,
      type,
      status,
    },
  });

  const watchTitle = watch('title');
  const watchType = watch('type');
  const watchStatus = watch('status');

  const ACTIVITY_STATUS = [
    {
      id: 1,
      name: '未开始',
      value: 'NOT_START',
    },
    {
      id: 2,
      name: '进行中',
      value: 'UNDER_WAY',
    },
    {
      id: 3,
      name: '已结束',
      value: 'COMPLETE',
    },
    {
      id: 4,
      name: '已暂停',
      value: 'PAUSED',
    },
    {
      id: 5,
      name: '待审核',
      value: 'UNAPPROVED',
    },
  ];

  //查询
  const handleSubmitSuccess = (values) => {
    handleSearch(values);
  };

  const resetData = () => {
    reset({
      title: '',
      type: '',
      status: '',
    });
    setValue('title', ' ');
    setValue('type', '');
    setValue('status', '');
    restClick && restClick();
  };

  const handleClearStatus = () => {
    setValue('status', '');
  };

  const handleClearType = () => {
    setValue('type', '');
    // reset('type', '');
  };

  return (
    <SearchConditionStyled theme={theme}>
      <form onSubmit={handleSubmit(handleSubmitSuccess)}>
        <div className="card-content-wrap">
          <Box className="left">
            <Controller
              as={
                <TextField
                  control={control}
                  id="basic"
                  className="single-select"
                  label={formatMessage({ id: 'marketing.scene.n09.lbl01' })}
                  // defaultValue={''}
                  // value={title}
                  variant="standard"
                  placeholder={''}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          className="clear-btn"
                          onClick={() => {
                            // setInputTitle('');
                            setValue('title', '');
                            // reset('title', '');
                          }}
                          edge="end"
                        >
                          {watchTitle && <ClearIcon className="clear-icon" />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              }
              control={control}
              name="title"
              placeholder=""
            />
            <FormControl variant="standard" className="gender single-select">
              <InputLabel>
                {formatMessage({ id: 'marketing.scene.n09.rdo02' })}
              </InputLabel>
              <Controller
                as={
                  <Select className="select">
                    {ACTIVITY_TYPE_DICT &&
                      ACTIVITY_TYPE_DICT.map((item) => (
                        <MenuItem
                          key={item.dictValue}
                          value={item.dictCode}
                          name={item.nameZh}
                        >
                          {item.nameZh}
                        </MenuItem>
                      ))}
                  </Select>
                }
                defaultValue=""
                name="type"
                control={control}
              />
              <ClearIconML
                handleClick={handleClearType}
                clearValue={watchType}
              ></ClearIconML>
            </FormControl>

            <FormControl variant="standard" className="gender single-select">
              <InputLabel>
                {formatMessage({ id: 'marketing.scene.n09.rdo03' })}
              </InputLabel>
              <Controller
                as={
                  <Select className="select">
                    {ACTIVITY_STATUS &&
                      ACTIVITY_STATUS.map((item) => (
                        <MenuItem
                          key={item.id}
                          value={item.value}
                          name={item.name}
                        >
                          {item.name}
                        </MenuItem>
                      ))}
                  </Select>
                }
                defaultValue=""
                label="状态"
                name="status"
                control={control}
              />
              <ClearIconML
                handleClick={handleClearStatus}
                clearValue={watchStatus}
              ></ClearIconML>
            </FormControl>
          </Box>
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              type="reset"
              className="reset"
              onClick={() => resetData()}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {/* 重置 */}
              {formatMessage({ id: 'cm.member.n01.btn10' })}
            </Button>
            <Button
              data-log={JSON.stringify({
                oid: 'btn_marketing_activity_scene_marketing_list_search',
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                },
              })}
              ref={searchRef}
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {/* 查询 */}
              {formatMessage({ id: 'cm.analysis.n01.btn06' })}
            </Button>
          </Box>
        </div>
      </form>
    </SearchConditionStyled>
  );
};

export default SearchCondition;
